import React from 'react';
import { Link } from 'react-router-dom';
import RoutesApp from '../../routes';

//Services
import { useGlobalContext } from '../../contexts/GlobalContext';

//Estilos
import './Navbar.css';
import logo from '../../assets/imgs/logo_inavi.png';
import help from '../../assets/imgs/question.png';

//Componentes
import HelpContainer from '../help/HelpContainer';

function Navbar({ functions, states }) {
    const { user, masters } = useGlobalContext();
    const { buildNavbarItems, setOpenHelp } = functions;
    const { navbarItems, openHelp } = states;
    const TIPO_USUARIO = masters?.UserTypes
        ? masters?.UserTypes.find((m) => m.id === user.tipo).nombre
        : null;

    return (
        <nav className="navbar-container">
            <div className="navbar-subcont_1">
                <Link to={RoutesApp.Home}>
                    <img alt="logo" src={logo} className="navbar-logo" />
                </Link>
                <div className="navbar-title_container">
                    <h4 className="navbar-title">{`${user?.apellido}, ${user?.nombre}`}</h4>
                    <h4 className="navbar-title">{`${TIPO_USUARIO}`}</h4>
                </div>
                <div onClick={() => setOpenHelp(true)}>
                    <img
                        className="navbar-help_container"
                        src={help}
                        title="Ayuda"
                        alt="Ayuda"
                        style={{ width: '1.5rem' }}
                    />
                </div>
            </div>
            <div className="navbar-subcont_2">
                {buildNavbarItems(navbarItems)}
            </div>
            {openHelp && (
                <HelpContainer
                    isOpen={openHelp}
                    onClose={() => setOpenHelp(false)}
                />
            )}
        </nav>
    );
}

export default Navbar;
